export const CheckSvg = () => {
	return (
		<svg
			width="100"
			height="100"
			viewBox="0 0 100 100"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle
				id="circle"
				cx="50"
				cy="50"
				r="45"
				fill="none"
				stroke="#4CAF50"
				strokeWidth="5"
			/>
			<path
				id="check"
				d="M30 55 L45 70 L70 35"
				fill="none"
				stroke="#4CAF50"
				strokeWidth="5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<style>
				{`
					#circle {
						stroke-dasharray: 283; /* 2πr for r=45 */
						stroke-dashoffset: 283;
						animation: draw-circle 0.4s ease-out forwards;
					}

					#check {
						stroke-dasharray: 100;
						stroke-dashoffset: 100;
						animation: draw-check 0.4s ease-out forwards;
						animation-delay: 0.4s;
					}

					@keyframes draw-circle {
						to {
							stroke-dashoffset: 0;
						}
					}

					@keyframes draw-check {
						to {
							stroke-dashoffset: 0;
						}
					}
				`}
			</style>
		</svg>
	);
};
